/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestnoplacesleft3Inputs */

const en_requestnoplacesleft3 = /** @type {(inputs: Requestnoplacesleft3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No places left`)
};

const de_requestnoplacesleft3 = /** @type {(inputs: Requestnoplacesleft3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Platz mehr frei`)
};

/**
* | output |
* | --- |
* | "No places left" |
*
* @param {Requestnoplacesleft3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestnoplacesleft3 = /** @type {((inputs?: Requestnoplacesleft3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestnoplacesleft3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestnoplacesleft3(inputs)
	return de_requestnoplacesleft3(inputs)
});
export { requestnoplacesleft3 as "requestNoPlacesLeft" }